<template>
  <section class="trendsreport-page">
    <TrendsReportIndexPage
      v-if="!product"
      :auth-user="authUser"
      @site-notification="handleSiteNotification"
    />
    <TrendsReportArticlePage
      v-if="selectedProduct"
      :auth-user="authUser"
      :selected-product="selectedProduct"
      :selected-product-type="selectedProductType"
      :more-products="moreProducts"
      :parent-slug="parentSlug"
      :app_url="app_url"
    />
    <SiteNotifications ref="site-notifications" />
  </section>
</template>

<script>
  import TrendsReportIndexPage from '~/pages/trendsreport/trendsreport-index-page.vue';
  import TrendsReportArticlePage from '~/pages/trendsreport/trendsreport-article-page.vue';
  import SiteNotifications from '~/components/site/SiteNotifications.vue';

  export default {
    name: 'trendsreport-home-page',
    components: {
      TrendsReportIndexPage,
      TrendsReportArticlePage,
      SiteNotifications,
    },
    props: {
      authUser: {
        type: Object,
        required: true,
      },
      product: {
        type: Object,
        required: false,
      },
      productType: {
        type: Object,
        required: false,
      },
      products: {
        type: Array,
        required: false,
      },
      slug: {
        type: String,
        required: false,
      },
      app_url: {
        type: String,
        required: false,
      },
    },
    data: () => ({
      selectedProduct: null,
      selectedProductType: null,
      moreProducts: null,
      parentSlug: null,
      currentPath: window.location.href,
    }),
    mounted() {
      if (this.product) {
        this.selectedProduct = this.product;
      }
      if (this.productType) {
        this.selectedProductType = this.productType.type;
      }
      if (this.products) {
        this.moreProducts = this.products;
      }
      if (this.slug) {
        this.parentSlug = this.slug;
      }
    },
    methods: {
      handleSiteNotification({ message, color }) {
        this.$refs['site-notifications'].addNotification({ message, color });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .trendsreport-page {
    min-height: 70vh;
  }
</style>
